import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { UserIconComponent } from '../../../app/core/svg-icons/user-icon.component';

const meta: Meta<UserIconComponent> = {
  title: 'Atoms/Icons/UserIcon',
  component: UserIconComponent,
  parameters: {
    docs: {
      description: {
        component: 'A user profile icon component. Commonly used for user authentication, profile sections, and account-related features.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<UserIconComponent>;

export const Default: Story = {
  render: () => ({
    template: '<app-user-icon></app-user-icon>',
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-user-icon')).toBeTruthy();
  },
};

export const InButton: Story = {
  render: () => ({
    template: `
      <button class="btn btn-primary-supervin" style="display: flex; align-items: center; gap: 0.5rem;">
        <app-user-icon></app-user-icon>
        <span>Min Konto</span>
      </button>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'User icon used inside a button for account access.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-user-icon')).toBeTruthy();
  },
};

export const InNavigation: Story = {
  render: () => ({
    template: `
      <nav style="background-color: #5C0A31; padding: 1rem;">
        <div style="display: flex; align-items: center; gap: 1rem; color: white;">
          <app-user-icon></app-user-icon>
          <span>Velkommen, bruger</span>
        </div>
      </nav>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'User icon in navigation context with wine-colored background.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-user-icon')).toBeTruthy();
  },
};

export const MultipleUses: Story = {
  render: () => ({
    template: `
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem;">
        <div>
          <h4>Header Navigation</h4>
          <div style="display: flex; align-items: center; gap: 0.5rem;">
            <app-user-icon></app-user-icon>
            <span>Log ind</span>
          </div>
        </div>
        <div>
          <h4>User Profile Card</h4>
          <div style="border: 1px solid #ddd; padding: 1rem; border-radius: 8px;">
            <div style="display: flex; align-items: center; gap: 1rem;">
              <app-user-icon></app-user-icon>
              <div>
                <strong>John Doe</strong><br>
                <small>Premium kunde</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Various use cases for the user icon component.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-user-icon')).toBeTruthy();
  },
};
